import * as R from 'ramda'
import { dataWisCreate } from '@weblite/action/wis'
import { WappInput } from '@weblite-wapps/protocol'
import { wsReq } from '$setup/ws'
import { wisesStorage } from '$logic/wises/storage'
import { Wis } from '$logic/wises/types'

export const createWisInServer = (wappId: string, input?: WappInput) =>
  wsReq(dataWisCreate({ wappId, customize: input }))
    .then(R.prop('payload'))
    .then(R.tap(console.log))
    .then(R.tap((wis: Wis) => wisesStorage.add(wis)))

export function getWis(id: string) {
  return wisesStorage.get(id)
}
